import { Navbar, NavigationIcon } from '@frontend/components/mobile';
import { LuHouse, LuTag, LuUser } from 'react-icons/lu';
import { TbActivity } from 'react-icons/tb';
import { FormattedMessage } from 'react-intl';

import { useMenuRepository } from '../menu/menu-repository';

interface DefaultFooterProps {
    disabled?: string[];
}

const DefaultFooter = (props: DefaultFooterProps) => {
    const { isLoading, currentApp } = useMenuRepository();
    return (
        <Navbar>
            <NavigationIcon
                text={
                    <FormattedMessage
                        id='mobile.footer.home'
                        description='The home button on the mobile footer'
                        defaultMessage='Home'
                    />
                }
                icon={LuHouse}
                link={`${currentApp ? `${currentApp}/` : ''}home`}
                disabled={isLoading || props.disabled?.includes('home')}
            />
            <NavigationIcon
                text={
                    <FormattedMessage
                        id='mobile.footer.activity'
                        description='The Activity button on the mobile footer'
                        defaultMessage='Activity'
                    />
                }
                icon={TbActivity}
                link={`${currentApp}/activities`}
                disabled={isLoading || !currentApp || props.disabled?.includes('activities')}
            />
            <NavigationIcon
                text={
                    <FormattedMessage
                        id='mobile.footer.items'
                        description='The Items button on the mobile footer'
                        defaultMessage='Items'
                    />
                }
                icon={LuTag}
                link={`${currentApp}/items`}
                disabled={isLoading || !currentApp || props.disabled?.includes('items')}
            />
            <NavigationIcon
                text={
                    <FormattedMessage
                        id='mobile.footer.profile'
                        description='The Profile button on the mobile footer'
                        defaultMessage='Profile'
                    />
                }
                icon={LuUser}
                link='profile'
                disabled={props.disabled?.includes('profile')}
            />
        </Navbar>
    );
};

export default DefaultFooter;
